import React, { useContext, useEffect, useState } from 'react';
import JobListViewContext, { RightClickContext } from '../common/JobListViewContext';
import { JobNames, getJobNameByTbName } from '../../framework.core/JobNames';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../ui/ActionButton';
import ToolboxMenuItem from '../../uiControls/ToolboxMenuItem';
import ListViewShortcutMenu from '../common/ListViewShortcutMenu';
import useFunctionKeys from '../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../uiControls/infoArea/InfoAreaDrawer';
import AbstractListView, { DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer, ListOrderBy, ListRowRenderer } from '../common/AbstractListView';
import { Search } from '../../filtering';
import constants from '../../constants';
import { DateRenderer, DateTimeRenderer, FloatRenderer, NullableCheckboxIconRenderer, TextAlignLeftRenderer, TextRenderer } from '../../uiControls/SmartTableRenderers';
import { TableColumn, TableSettings, utCommunicationListItem } from '../../tableSettings';
import JobListSuntekCommand from '../common/JobListSuntekCommand';
import * as XCol from '../../framework.core/XExportColumn';
import Menu, { IfmsMenuItem } from '../../ui/menu/Menu';
import { DocumentType } from '../../framework.core/DocumentType';
import { UTCommunicationListItem } from '../../fms.data/models/UTCommunicationListItem';
import Select from '../../ui/Select';
import { useHistory } from 'react-router';
import { NavigationType, openNewPage } from '../../util/navigationHelpers';
import { getJobNameBySourceType, getListUrlWithSecCheck, getOredrByJobName } from '../../util';
import ApplicationContext from '../../ApplicationContext';
import useGlobalOkDialog from '../../hooks/useGlobalOkDialog';

function useOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
   const [showGlobalOkDialog] = useGlobalOkDialog();

  function switchRelatedFor(row: UTCommunicationListItem | null) {
    if (!row || !row.tbName || !row.tbId) return;
    
    let jobName = getJobNameByTbName(row.tbName);
    if(jobName === JobNames.None) jobName = getJobNameBySourceType(row.sourceType);

    const orderBy = getOredrByJobName(jobName);
    const listUrl = getListUrlWithSecCheck(appContext, jobName, showGlobalOkDialog);

    if(!listUrl) return; 

    jobListContext.setFilterForScreenExternally(listUrl, 'id', '', row.tbId.toString(), orderBy, false, true);
    openNewPage(history, listUrl, NavigationType.newPage);
  }
  return { switchRelatedFor };
}

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);   

  const { switchRelatedFor } = useOperations();

  function switchRelated() {
    const selectedElement = jobListContext.selectedElement as UTCommunicationListItem;
    switchRelatedFor(selectedElement);
  }
  return {switchRelated};
}

function RightClickMenu({ dismiss }: { dismiss: VoidFunction }) {
  const jobListContext = useContext(JobListViewContext);
  const { switchRelated } = useSelectedOperations();

  const items = [
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Refresh', shortcut: 'F11', separator: true },
    { label : 'Go to Related List', shortcut: 'F6', separator: false},
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) => ({
    label: <ToolboxMenuItem width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    index,
  }));

  function onMenuItemSelected(item: IfmsMenuItem) {
    switch (item.index) {
      case 0:
        jobListContext.triggerTableSearch('F5');
        break;
      case 1:
        jobListContext.reloadData();
        break;
      case 2:
        switchRelated();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function LogTypeFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { label: 'Email', value: 'Email'},
        { label: 'Print', value: 'Print' },
        { label: 'Fax', value: 'Fax' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

function ListCommands() {
  return (
    // <div className="ifms-common-no-vertical-separator">
    //   <UniqueLinkButton display="primary" size="regular" link={''} disabled
    //                     label={<span><FontAwesomeIcon icon={faPlus}/>&nbsp; New</span>}/>&nbsp;
    //   <PrimaryButton size="regular" disabled ><FontAwesomeIcon
    //     icon={ViewIcon}/>&nbsp; View</PrimaryButton>&nbsp;
    //   <PrimaryButton size="regular" disabled ><FontAwesomeIcon
    //     icon={EditIcon}/>&nbsp; Edit</PrimaryButton>&nbsp;
    //   <PrimaryButton size="regular" disabled ><FontAwesomeIcon
    //     icon={DeleteIcon}/>&nbsp; Delete</PrimaryButton>&nbsp;
    // </div>
    <></>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function formatLogType(s: string | null | undefined) {
  if (!s) {
    return s;
  }

  if (s === 'E') {
    return 'Email';
  }
  if (s === 'F') {
    return 'Fax';
  }
  if (s === 'P') {
    return 'Print';
  }

  return s
}

function LogTypeRenderer({ cell }: any) {
  let additionalStyle = {color: 'black'}
  let value = cell.value??'';
  if (value === 'E') {
    // additionalStyle = {color: '#0000FF'};
    value = 'Email';
  }
  if (value === 'F') {
    additionalStyle = {color: '#800080'};
    value = 'Fax';
  }
  if (value === 'P') {
    additionalStyle = {color: '#008000'};
    value = 'Print';
  }

  return (
    // <div className="ifms-table-default" >{formatLogType(cell.value)}</div>
    <div className="ifms-table-default" style={additionalStyle}>{value}</div>
  );
}

function ListViewExtras() {
  useFunctionKeys({ onFunction: onFunctionKey });
  const jobListContext = useContext(JobListViewContext);
  
  const { switchRelated } = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
    if (!unprocessedFkey) {
      return;
    }

    doProcessFkey();
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F5") {
      jobListContext.triggerTableSearch('F5');
    } else if (unprocessedFkey === "F6") {
      switchRelated();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F5', 'F6', 'F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.LogCommunication}
      jobId={(jobListContext.selectedElement as UTCommunicationListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

/**
 *
 * @class EmailLogListView
 * @extends {AbstractListView}
 */
class EmailLogListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.LogCommunication,
      'UTCommunicationListItem',
      UTCommunicationListItem.calculateSearchParameters(search, UTCommunicationListItem.MapSearchFields),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return { data: [], totalCount: 0 };
    }

    return { data: UTCommunicationListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount };
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.LogCommunication, 'UTCommunicationListItem',
      UTCommunicationListItem.calculateSearchParameters(search, UTCommunicationListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  UTCommunicationListItem.formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'logType',
        renderer: LogTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v === 'Email' ? 'E' : v === 'Fax' ? 'F' : 'P',
      }
    ];
  }

  getInfoAreaEntityId() {
    return constants.opTypes.utility;
  }

  getRowRenderers(): ListRowRenderer[] {
    return UTCommunicationListItem.getExportCollection().map(x => {
      const colRenderer: ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if (x.dataIndex === "logType") colRenderer.Cell = LogTypeRenderer;
      if (x.type === XCol.XCellType.Double) colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      else if (x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'postDate',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings = utCommunicationListItem;
    const cols = UTCommunicationListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type };
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands />
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar />
    );
  }


  hasMemo(): boolean {
    return false;
  }
  renderExtras() {
    return <ListViewExtras />
  }

  getViewUrlFor(row: UTCommunicationListItem) {
    return '';
  }

  getOpenUrlFor(row: UTCommunicationListItem) {
    function sanitizeFileName(fileName: string) {
      return fileName
        ?.replaceAll(/\:/g, '-')                // 윈도우 파일시스템 제한 문자
        ?.replaceAll(/[/\\?%*|"<>+]/g, ' ')     // 윈도우 파일시스템 제한 문자 && 업로드 파일 URL 호출 시 특수문자가 포함되어 있을 경우 에러가 발생함("+" 문자 추가)
        ?.replaceAll(/\./g, ' ')                // 마침표를 공백으로            ???
        ?.replaceAll(/\#/g, ' ')                // #을 공백으로                ???
        ?.replaceAll(/\s+/g, ' ')               // 연속된 공백을 하나로
        ?.trim();                               // 앞뒤 공백 제거
    }

    let url = '';
    const title = sanitizeFileName(row.title);
    if (row.logType === 'E')
      url = `&logFileId=${row.logFileId}&logHeaderId=${row.idex}&docType=${DocumentType.LogEmail}&oriLogFileTitle=${title}`;

    else if (row.logType === 'P')
      url = `&logFileId=${row.logFileId}&logHeaderId=${row.idex}&docType=${DocumentType.LogPrint}&oriLogFileTitle=${title}`;

    else
      url = `&logFileId=${row.logFileId}&logHeaderId=${row.idex}&docType=${DocumentType.LogFax}&oriLogFileTitle=${title}`;

    return url;
  }

  getListViewTitle() {
    return 'Communication Log List';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.LogCommunication} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }
}

export default EmailLogListView;